import { IonCol, IonGrid, IonImg, IonRow } from "@ionic/react";
import { getStopActivity } from "../../../models/stopActivity.model";
import React from "react";
import { checkForDeadHeadWeb, detectSeachPath, convertDeadheadToInt } from '../../../utils/Deadhead'

import "./MyloadStopDetails.scss";

export const MyloadStopDetails: React.FunctionComponent<any> = (props: any) => {
  const stopDetail = props.stopDetails;

  const renderDeadHead = () => {
    return (
      <>
      {stopDetail.deadHead !== null &&
        <p className="origin_dateTime load_header_elements stop-appointment">
        Deadhead {`${convertDeadheadToInt(stopDetail.deadHead)} ${props.load.distanceUOM}`}
      </p>
    }
    </>
    );
  }

  return (
    <React.Fragment>
      <IonGrid class="stop-data-grid stop-data-grid-with-map myload-stops">
        {props.index < props.length - 1 ? (
          <>
            {props.index === 0 ? (
              <IonImg
                className="stop-icon route-icon"
                src="assets/icon/origin-pointer.svg"
              />
            ) : (
                <IonImg
                  className="stop-icon route-icon"
                  src="assets/icon/stop-pointer.svg"
                />
              )}
          </>
        ) : (
            <IonImg className="path_icon route-icon" src="assets/icon/dst-pointer.svg" />
          )}
        <IonRow>
          <IonCol size="6">
            <IonGrid className="stop-address-grid">
              <p className="origin_city load-stop-name">
                {`${stopDetail && stopDetail.city}, ${stopDetail &&
                  stopDetail.state}`}
              </p>

              {stopDetail && stopDetail.locationName && (
                <p className="address-location-name">
                  {stopDetail.locationName}
                </p>
              )}

              {stopDetail && stopDetail.addressLine1 && (
                <p className="address-details">{stopDetail.addressLine1}</p>
              )}

              {stopDetail && stopDetail.addressLine2 && (
                <p className="address-details">{stopDetail.addressLine2}</p>
              )}

              <p className="address-details">
                {stopDetail.city}, {stopDetail.state}, {stopDetail.postalCode}
              </p>
            </IonGrid>
          </IonCol>
          <IonCol size="6">
            <IonGrid className="stop-address-grid">
              {(detectSeachPath(props.history.location.pathname) ||
                checkForDeadHeadWeb(props, stopDetail)) && !props.isMatchedLoadPage ? (
                  <p className="origin_dateTime load_header_elements stop-appointment margin_top">
                    {props.appointment}
                  </p>
                ) : null}
              <div className="margin_height" />
              <p className="origin_milehead load_header_elements stop-activity">
                {getStopActivity(
                  (stopDetail && stopDetail.stopActivity) ||
                  (stopDetail && stopDetail.specialServices) ||
                  [],
                  props.isCarrierLoad,
                  stopDetail.stopType
                )}
              </p>
              <div className="margin_height" />
              {(!detectSeachPath(props.history.location.pathname) && !checkForDeadHeadWeb(props, stopDetail)) || props.isMatchedLoadPage ? (
                <p className="origin_dateTime load_header_elements stop-appointment">
                  {props.appointment}
                </p>
              ) : null}
              {checkForDeadHeadWeb(props, stopDetail) ? renderDeadHead() : null}
            </IonGrid>
          </IonCol>
        </IonRow>
      </IonGrid>
    </React.Fragment>
  );
};
